import { createContext } from "react";

interface Props {
  label?: string;
  subLabel?: string;
  showNonBiometricIdSection: boolean;
  setShowNonBiometricIdSection: (show: boolean) => void;
  handleChange: (path: string, value: unknown) => void;
  fallbackPollTimeout: number;
  optedOutOfBiometricId?: boolean;
  optedOutOfNonBiometricId?: boolean;
  nonBioIdOptOutReason?: string;
  nonBioIdOptOutOtherReason?: string;
  oneIdAlternativesEligibility?: {
    fallback_type: string;
  };
  mutate: () => void;
  idvCheckTypes?: string[] | undefined;
  mutateIdvCheck: () => void;
  onFallbackTriggered?: () => void;
  consumer?: boolean;
}

export const OneIdLayoutContext = createContext<Props>({
  label: "",
  subLabel: "",
  showNonBiometricIdSection: false,
  setShowNonBiometricIdSection: () => {},
  handleChange: () => {},
  fallbackPollTimeout: 15,
  mutate: () => {},
  idvCheckTypes: undefined,
  mutateIdvCheck: () => {},
  onFallbackTriggered: () => {},
  consumer: false,
});
